
/**
 * 트윗 유형
 */
export type ExploreContentItemContentOneOfReferencedTweetTweetBasicInfoAllOfTwoTweetType = typeof ExploreContentItemContentOneOfReferencedTweetTweetBasicInfoAllOfTwoTweetType[keyof typeof ExploreContentItemContentOneOfReferencedTweetTweetBasicInfoAllOfTwoTweetType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ExploreContentItemContentOneOfReferencedTweetTweetBasicInfoAllOfTwoTweetType = {
  ORIGINAL: 'ORIGINAL',
  REPLY: 'REPLY',
  QUOTE: 'QUOTE',
  RETWEET: 'RETWEET',
} as const;
